import Reveal from "./Reveal";

export default function PricingTable({ titre, rows, testid = "tableau-tarifs" }) {
  return (
    <Reveal>
      <div className="bg-brand-light p-6 sm:p-10" data-testid={testid}>
        <h2 className="font-heading font-bold uppercase text-3xl sm:text-4xl text-brand-navy mb-6 tracking-tight">
          {titre}
        </h2>
        <table className="w-full text-left border-collapse">
          <caption className="sr-only">{titre}</caption>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-brand-light"}>
                <th scope="row" className="font-heading font-semibold uppercase tracking-wide text-brand-dark text-base sm:text-lg px-4 sm:px-6 py-4">
                  {r.prestation}
                </th>
                <td className="text-right font-heading font-bold text-brand-red text-lg sm:text-xl px-4 sm:px-6 py-4 whitespace-nowrap">
                  {r.prix}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Reveal>
  );
}
